import { I18n } from '@calendly/i18n'
import { Table, Header, Body, HeaderCell } from '@calendly/table'
import { VisuallyHidden } from '@calendly/ui/components/visually-hidden'

import { TokenRow } from './token_row'

export const TokensTable = ({ bearerTokens }) => {
  if (bearerTokens.length === 0) return null

  return (
    <div data-component="bearer-tokens">
      <Table borderless noContainerBorder>
        <Header>
          <HeaderCell>
            {I18n.t('publisher.organization_settings.user_provisioning.scim_configuration.bearer_token.generated_on')}
          </HeaderCell>
          <HeaderCell>
            {I18n.t('publisher.organization_settings.user_provisioning.scim_configuration.bearer_token.expires_at')}
          </HeaderCell>
          <HeaderCell hugContent>
            <VisuallyHidden>
              {I18n.t('publisher.organization_settings.user_provisioning.scim_configuration.bearer_token.actions_header')}
            </VisuallyHidden>
          </HeaderCell>
        </Header>
        <Body>
          {bearerTokens.map((bearerToken) => <TokenRow bearerToken={bearerToken} key={bearerToken.id} />)}
        </Body>
      </Table>
    </div>
  )
}
